import { render, staticRenderFns } from "./CompanyDefault.vue?vue&type=template&id=5148cc74&scoped=true"
import script from "./CompanyDefault.vue?vue&type=script&lang=js"
export * from "./CompanyDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148cc74",
  null
  
)

export default component.exports